"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.bindGlobalSyntheticSelectionEvents = exports.lastMouseClickChangedTargetBetweenDownAndUp = exports.useSelectionStore = exports.SyntheticSelectionStore = exports.SyntheticSelectionEvent = void 0;
var inversify_react_1 = require("inversify-react");
var mobx_1 = require("mobx");
var react_1 = __importDefault(require("react"));
var slate_1 = require("slate");
var EditorTypes_1 = require("./QwilrEditor/EditorTypes");
var PasteUtilities_1 = require("./QwilrEditor/PasteUtilities");
var lodash_1 = require("lodash");
var SelectionRing_1 = require("./QwilrEditor/RegistryElement/SelectionRing");
var DragHandle_css_1 = require("./QwilrEditor/RegistryElement/DragHandle.css");
var getRouterAndPathFromSelection = function (syntheticSelectionStore) {
    var _a;
    var selection = (_a = syntheticSelectionStore.selection) === null || _a === void 0 ? void 0 : _a[0];
    return { router: selection === null || selection === void 0 ? void 0 : selection.router, editor: selection === null || selection === void 0 ? void 0 : selection.editor };
};
var SyntheticSelectionEvent = (function (_super) {
    __extends(SyntheticSelectionEvent, _super);
    function SyntheticSelectionEvent(data) {
        var _this = _super.call(this, EditorTypes_1.EventType.SyntheticSelection) || this;
        _this.data = data;
        return _this;
    }
    return SyntheticSelectionEvent;
}(EditorTypes_1.CustomEvent));
exports.SyntheticSelectionEvent = SyntheticSelectionEvent;
var SyntheticSelectionStore = (function () {
    function SyntheticSelectionStore() {
        this._selection = [];
    }
    Object.defineProperty(SyntheticSelectionStore.prototype, "selection", {
        get: function () {
            return this._selection;
        },
        enumerable: false,
        configurable: true
    });
    SyntheticSelectionStore.prototype.setSelection = function (selection) {
        this._selection = selection;
    };
    SyntheticSelectionStore.prototype.toggleSelection = function (selections) {
        var e_1, _a;
        var _b, _c;
        if (!selections.length)
            return;
        var existingSelection = this._selection;
        if (existingSelection.length) {
            var toggleSelectionIsFromEditorOfExistingSelection = ((_b = existingSelection[0]) === null || _b === void 0 ? void 0 : _b.editor) === ((_c = selections[0]) === null || _c === void 0 ? void 0 : _c.editor);
            if (!toggleSelectionIsFromEditorOfExistingSelection) {
                this.setSelection(selections);
                return;
            }
        }
        var ancestorOrDescendantExistingSelections = existingSelection.filter(function (selection) {
            return selections.find(function (s) {
                return selection.editor === s.editor &&
                    (slate_1.Path.isAncestor(selection.path, s.path) || slate_1.Path.isAncestor(s.path, selection.path));
            });
        });
        if (ancestorOrDescendantExistingSelections.length) {
            this.removeFromSelection(ancestorOrDescendantExistingSelections);
            this.addToSelection(selections);
            return;
        }
        var _loop_1 = function (selection) {
            var currentlySelected = existingSelection.find(function (_a) {
                var editor = _a.editor, path = _a.path;
                return editor === selection.editor && (0, lodash_1.isEqual)(path, selection.path);
            });
            if (currentlySelected) {
                this_1.removeFromSelection([selection]);
            }
            else {
                this_1.addToSelection([selection]);
            }
        };
        var this_1 = this;
        try {
            for (var selections_1 = __values(selections), selections_1_1 = selections_1.next(); !selections_1_1.done; selections_1_1 = selections_1.next()) {
                var selection = selections_1_1.value;
                _loop_1(selection);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (selections_1_1 && !selections_1_1.done && (_a = selections_1.return)) _a.call(selections_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    SyntheticSelectionStore.prototype.addToSelection = function (selections) {
        var _this = this;
        var notYetSelected = selections.filter(function (selection) {
            return !_this._selection.find(function (_a) {
                var editor = _a.editor, path = _a.path;
                return editor === selection.editor && (0, lodash_1.isEqual)(path, selection.path);
            });
        });
        this._selection = __spreadArray(__spreadArray([], __read(this._selection), false), __read(notYetSelected), false);
    };
    SyntheticSelectionStore.prototype.removeFromSelection = function (selections) {
        this._selection = this._selection.filter(function (_selected) {
            var inSelectionsToRemove = !!selections.find(function (selected) { return _selected.editor === selected.editor && (0, lodash_1.isEqual)(_selected.path, selected.path); });
            return !inSelectionsToRemove;
        });
    };
    SyntheticSelectionStore.prototype.clearSelection = function () {
        this._selection = [];
    };
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Array)
    ], SyntheticSelectionStore.prototype, "_selection", void 0);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], SyntheticSelectionStore.prototype, "setSelection", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], SyntheticSelectionStore.prototype, "toggleSelection", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], SyntheticSelectionStore.prototype, "addToSelection", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], SyntheticSelectionStore.prototype, "removeFromSelection", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], SyntheticSelectionStore.prototype, "clearSelection", null);
    return SyntheticSelectionStore;
}());
exports.SyntheticSelectionStore = SyntheticSelectionStore;
var useSelectionStore = function () {
    var store = (0, inversify_react_1.useInjection)("syntheticSelectionStore");
    var _a = __read(react_1.default.useState(store.selection), 2), selection = _a[0], setSelection = _a[1];
    react_1.default.useEffect(function () {
        var disposer = (0, mobx_1.reaction)(function () {
            return store.selection;
        }, function (data) {
            setSelection(data);
        }, { fireImmediately: false });
        return disposer;
    }, [store]);
    return {
        selection: selection,
        setSelection: store.setSelection,
        toggleSelection: store.toggleSelection,
        addToSelection: store.addToSelection,
        removeFromSelection: store.removeFromSelection,
        clearSelection: store.clearSelection,
    };
};
exports.useSelectionStore = useSelectionStore;
var SLATE_TOOLBAR_ELEMENTS = ["#popover-root", "#toolbar-root", "#combobox-root", "#option-menu-root"];
var lastMouseDownElement;
var lastMouseUpElement;
var lastMouseClickChangedTargetBetweenDownAndUp = function () {
    return lastMouseDownElement !== lastMouseUpElement;
};
exports.lastMouseClickChangedTargetBetweenDownAndUp = lastMouseClickChangedTargetBetweenDownAndUp;
var isTargetWidgetMenu = function (event) { var _a; return !!(event.target instanceof HTMLElement && ((_a = event.target.parentElement) === null || _a === void 0 ? void 0 : _a.classList.contains(DragHandle_css_1.widgetMenu))); };
var shouldHandleEvent = function (event) {
    var targetIsBody = event.target === document.body;
    var targetIsDragHandle = event.target instanceof HTMLElement && event.target.hasAttribute("data-drag-handle");
    var targetIsWidgetMenu = isTargetWidgetMenu(event);
    return targetIsBody || targetIsDragHandle || targetIsWidgetMenu;
};
var getKeydownEventAction = function (e) {
    if (e.key === "Enter")
        return "enter";
    if (e.key === "Backspace")
        return "backspace";
    if (e.key === "Delete")
        return "delete";
    if (e.key === "z" && (e.getModifierState("Control") || e.getModifierState("Meta")))
        return "undo";
    if (e.key === "ArrowUp")
        return "arrowUp";
    if (e.key === "ArrowDown")
        return "arrowDown";
};
var bindGlobalSyntheticSelectionEvents = function (_a) {
    var syntheticSelectionStore = _a.syntheticSelectionStore, uploadStore = _a.uploadStore;
    var handleMouseOutside = function (event) {
        if (!event.target)
            return;
        if (event.target.closest(SLATE_TOOLBAR_ELEMENTS.join(",")))
            return;
        var hasSelectionRing = !!(0, SelectionRing_1.getClosestSelectionRing)(event.target);
        if (hasSelectionRing) {
            return;
        }
        syntheticSelectionStore.clearSelection();
    };
    var clickOutsideDisposer = (0, mobx_1.reaction)(function () { return syntheticSelectionStore.selection; }, function (selection) {
        if (!!selection.length) {
            document.addEventListener("mousedown", handleMouseOutside);
        }
        else {
            document.removeEventListener("mousedown", handleMouseOutside);
        }
    }, { fireImmediately: false });
    var copyEventHandler = function (e) {
        if (!shouldHandleEvent(e))
            return;
        var _a = getRouterAndPathFromSelection(syntheticSelectionStore), router = _a.router, editor = _a.editor;
        if (!router || !editor)
            return;
        router.onEvent(new SyntheticSelectionEvent({
            originalEvent: e,
            action: "copy",
            selection: syntheticSelectionStore.selection,
        }), editor);
    };
    var cutEventHandler = function (e) {
        if (!shouldHandleEvent(e))
            return;
        var _a = getRouterAndPathFromSelection(syntheticSelectionStore), router = _a.router, editor = _a.editor;
        if (!router || !editor)
            return;
        var handled = router.onEvent(new SyntheticSelectionEvent({
            originalEvent: e,
            action: "cut",
            selection: syntheticSelectionStore.selection,
        }), editor);
        if (handled) {
            syntheticSelectionStore.clearSelection();
        }
    };
    var pasteEventHandler = function (e) {
        var _a;
        if (!shouldHandleEvent(e))
            return;
        e.preventDefault();
        var _b = getRouterAndPathFromSelection(syntheticSelectionStore), router = _b.router, editor = _b.editor;
        if (!router || !editor || !((_a = syntheticSelectionStore.selection[0]) === null || _a === void 0 ? void 0 : _a.conversionElem))
            return;
        (0, PasteUtilities_1.pasteHandler)(editor, function (insertEvent) {
            return router.onEvent(new SyntheticSelectionEvent({
                originalEvent: insertEvent,
                action: "paste",
                selection: syntheticSelectionStore.selection,
            }), editor);
        }, syntheticSelectionStore.selection[0].conversionElem, uploadStore)(e);
    };
    var keydownEventHandler = function (e) {
        if (!shouldHandleEvent(e))
            return;
        var _a = getRouterAndPathFromSelection(syntheticSelectionStore), router = _a.router, editor = _a.editor;
        if (!router || !editor)
            return;
        var action = getKeydownEventAction(e);
        if (!action)
            return;
        var dispatchEvent = function () {
            router.onEvent(new SyntheticSelectionEvent({
                originalEvent: e,
                action: action,
                selection: syntheticSelectionStore.selection,
            }), editor);
        };
        e.stopPropagation();
        if (isTargetWidgetMenu(e)) {
            document.body.dispatchEvent(new KeyboardEvent("keydown", { key: "Esc" }));
            (0, lodash_1.defer)(dispatchEvent);
        }
        else {
            dispatchEvent();
        }
    };
    var lastClickMouseDownHandler = function (e) {
        lastMouseDownElement = e.target;
    };
    var lastClickMouseUpHandler = function (e) {
        lastMouseUpElement = e.target;
    };
    document.addEventListener("copy", copyEventHandler);
    document.addEventListener("cut", cutEventHandler);
    document.addEventListener("paste", pasteEventHandler);
    document.addEventListener("keydown", keydownEventHandler, true);
    document.addEventListener("mousedown", lastClickMouseDownHandler);
    document.addEventListener("mouseup", lastClickMouseUpHandler);
    return function () {
        document.removeEventListener("mousedown", handleMouseOutside);
        clickOutsideDisposer();
        document.removeEventListener("copy", copyEventHandler);
        document.removeEventListener("cut", cutEventHandler);
        document.removeEventListener("paste", pasteEventHandler);
        document.removeEventListener("keydown", keydownEventHandler, true);
        document.removeEventListener("mousedown", lastClickMouseDownHandler);
        document.removeEventListener("mouseup", lastClickMouseUpHandler);
    };
};
exports.bindGlobalSyntheticSelectionEvents = bindGlobalSyntheticSelectionEvents;
